import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

const Popup = styled.div`
  position: absolute;
  top: 50%;
  left: calc(50% + 81px);
  transform: translate(-50%, -50%);
  transition: left 0.3s;

  ${(props) => props.type === 'audio' && css`
    width: 1344px;
    height: 756px;
    display: grid;
    grid-template-columns: 25% 75%;
    grid-template-rows: auto 109px 136px;
    overflow: hidden;

    ${(props) => props.book === 0 && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book1_bg_small.png) center / cover;'}
    ${(props) => props.book === 1 && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book2_bg_small.png) center / cover;'}
    ${(props) => props.book === 2 && 'background: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_book3_bg_small.png) center / cover;'}
  `}

  ${(props) => props.type === 'video' && css`
    display: flex;
    flex-direction: column;
    width: 768px;
    height: 514px;
  `}

  ${(props) => !props.menu && 'left : 50%;'}

  ${(props) => props.type === 'card' && css`
    width: 1152px;
    height: 756px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    position: relative;
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/flashCard/flashcard_book1_bg_gray.png);
  `}

  ${(props) => props.type === 'game' && css`
    background: center /cover no-repeat;

    ${props.book === 0 && css`
      width: 1318px;
      height: 868px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game1_bg.png);
    `}

    ${props.book === 1 && css`
      width: 1300px;
      height: 850px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game2_bg.png);
    `}

    ${props.book === 2 && css`
      width: 1300px;
      height: 850px;
      background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game3_bg.png);
    `}
  `}
`;

export const PopupFrame = (props) => {
  const state = useSelector((state) => state);

  return (
    <Popup type={props.type} book={state.book.current_book} menu={state.menu.act}>{props.children}</Popup>
  );
};

PopupFrame.propTypes = {
  type : PropTypes.string.isRequired
};

PopupFrame.defaultProps = {
  type : 'audio',
  book : 0
};